// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_Wl3lL","col_navlist":"index_col_navlist_e5AJu","pa":"index_pa_K6IEj"};